class Loading {
  $container = null;

  constructor() {
    this._initContainer();
  }

  /**
   * @public
   * 显示loading方法
   *
   * @param {string} [text='加载中...'] 图案下方显示的文字
   * @param {number} [duration=10] loading时长
   */
  show(text = `${window.TLang('加载中', 'my')}`, duration = 10) {
    /* 添加loading到DOM中 */
    const tpl = this._generateTemplate(
      text,
      `<svg viewBox="0 -2 59.75 60.25">
        <path
          fill="#ccc"
          d="M29.69-.527C14.044-.527 1.36 12.158 1.36 27.806S14.043 56.14 29.69 56.14c15.65 0 28.334-12.686 28.334-28.334S45.34-.527 29.69-.527zm.185 53.75c-14.037 0-25.417-11.38-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.38 25.417 25.417-11.38 25.416-25.417 25.416z"
        />
        <path
          fill="none"
          stroke="#108ee9"
          stroke-width="3"
          stroke-linecap="round"
          stroke-miterlimit="10"
          d="M56.587 29.766c.37-7.438-1.658-14.7-6.393-19.552"
        />
      </svg>`,
    );
    if (this.$container) {
      this.$container.innerHTML = tpl;
    }

    /**  duration > 0 代表自动不取消 */
    if (duration > 0) {
      /* 定时器结束后隐藏loading */
      setTimeout(() => {
        this._removeLoading();
      }, duration * 1000);
    }
  }

  hide() {
    this._removeLoading();
  }

  _removeLoading() {
    this.$container.innerHTML = '';
  }

  _generateTemplate(text, svgs) {
    return `<div class="common-loading">
            <div class="content">
                ${svgs}
                <div class="text">${text}</div>
            </div>
        </div>`;
  }

  /** 生成容器并append到DOM中 */
  _initContainer() {
    this.$container = document.createElement('div');
    this.$container.classList.add('common-loading-container');

    document.body.appendChild(this.$container);
  }
}

export default new Loading();
